export default __webpack_public_path__ + "static/styles-7704a732d015fe30fa2f06949f9c4d4c.jpg";